import CustomerContactSelect from "components/Customer/CustomerContactSelect";
import Spinner from "components/Spinner";
import ZplAddressLabelButton from "components/ZplLabel/ZplAddressLabelButton";
import { setNotification } from "features/Notification/notificationSlice";
import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

const buildBillingAddressQuery = (details) =>
  [
    details?.addressLine1,
    details?.addressLine2,
    details?.addressCity,
    details?.addressState,
    details?.addressZipCode,
    details?.addressCountry,
  ]
    .filter(Boolean)
    .join(", ");

function AccountPayable({ customerDetails, refreshFunc }) {
  const dispatch = useDispatch();
  /*   All States
   ********************************************* */
  const [showPayableModal, setShowPayableModal] = useState(false);
  const [formData, setFormData] = useState({ ...customerDetails });

  const [defaultShippingAddress, setDefaultShippingAddress] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  /*   All Functions`
   ********************************************* */
  const updateAccountPayable = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const updatedData = JSON.stringify({
      ...formData,
      id: customerDetails.id,
    });

    try {
      const { data } = await API.patch(
        "/customers",
        { updatedData },
        { headers: authHeader() }
      );
      if (data.success) {
        refreshFunc(customerDetails.id);
        setIsLoading(false);
        setShowPayableModal(false);
        return;
      }
      console.log(data);

      setIsLoading(false);
    } catch (err) {
      alert(err.message);
      setIsLoading(false);
    }
  };

  const getCustomerDefaultShipAddress = async (customerId) => {
    try {
      setIsLoading(true);

      const { data } = await API.post(
        "/customer/ship-address/default/" + customerId,
        {
          isPrimary: false,
        },
        {
          headers: authHeader(),
        }
      );

      if (data?.success) {
        setDefaultShippingAddress(data?.data || {});
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
      setIsLoading(false);
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setFormData(customerDetails);
  }, [customerDetails]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (customerDetails) {
        getCustomerDefaultShipAddress(customerDetails.customerId);
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [customerDetails.id]);

  return (
    <>
      <div className="row w-100">
        <div className="col-md-12">
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="border-bottom border-secondary">BILLING ADDRESS</h4>
            <div className="d-flex align-items-center gap-2">
              <ZplAddressLabelButton
                title="Print billing address label"
                lines={[
                  customerDetails?.addressCompany,
                  customerDetails?.addressContact,
                  [customerDetails?.addressLine1, customerDetails?.addressLine2]
                    .filter(Boolean)
                    .join(", "),
                  [
                    customerDetails?.addressCity,
                    customerDetails?.addressState,
                    customerDetails?.addressZipCode,
                  ]
                    .filter(Boolean)
                    .join(", "),
                ]}
              />
              <button
                type="button"
                className="btn btn-link p-0 border-0 lh-1"
                title="Verify address on Google Maps"
                disabled={!buildBillingAddressQuery(customerDetails)}
                onClick={() =>
                  window.open(
                    `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                      buildBillingAddressQuery(customerDetails)
                    )}`,
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                <i className="mdi mdi-map-marker-check fs-5"></i>
              </button>
              <button
                type="button"
                className="btn btn-link p-0 border-0 lh-1"
                title="Search address on Google"
                disabled={!buildBillingAddressQuery(customerDetails)}
                onClick={() =>
                  window.open(
                    `https://www.google.com/search?q=${encodeURIComponent(
                      buildBillingAddressQuery(customerDetails)
                    )}`,
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                <i className="mdi mdi-magnify fs-5"></i>
              </button>
              <button
                className="btn d-flex justify-content-center align-items-center btn-sm btn-success "
                style={{ width: 28, height: 28 }}
                onClick={() => {
                  setShowPayableModal(true);
                }}
              >
                <i className="mdi fs-5 mdi-pencil"></i>
              </button>
            </div>
          </div>
          <div className="d-flex">
            <div className="d-flex flex-column" style={{ minWidth: 110 }}>
              {/* Address Company Name */}
              <div className="">Customer</div>
              {/* <div className="">Contact</div> */}
              {/* Address 1 */}
              <div className="">Address 1</div>
              {/* Tracking ID */}
              <div className="">Address 2</div>
              {/* Tracking ID */}
              <div className="">City</div>
              {/* Void  */}
              <div className="">State</div>
              {/* Refference  */}
              <div className="">Zip Code</div>
              {/* Weight  */}
              <div className="">Country</div>
            </div>

            <div className="">
              {/* Website  */}
              <div className="">
                :&nbsp;&nbsp;&nbsp;
                <p className="d-inline text-truncate">
                  {customerDetails?.addressCompany
                    ? customerDetails.addressCompany
                    : "-"}
                </p>
              </div>
              {/* <div className="">
                :&nbsp;&nbsp;&nbsp;
                <p className="d-inline text-truncate">
                  {customerDetails?.addressContact
                    ? customerDetails.addressContact
                    : "-"}
                </p>
              </div> */}

              {/* Website  */}
              <div className="">
                :&nbsp;&nbsp;&nbsp;
                <p className="d-inline text-truncate">
                  {customerDetails?.addressLine1
                    ? customerDetails.addressLine1
                    : "-"}
                </p>
              </div>
              {/* Transit Days  */}
              <div className="w-50">
                :&nbsp;&nbsp;&nbsp;
                <p className="d-inline text-truncate ">
                  {customerDetails?.addressLine2
                    ? customerDetails.addressLine2
                    : "-"}
                </p>
              </div>
              {/* Customer Type  */}
              <div className="">
                <div className="">
                  :&nbsp;&nbsp;&nbsp;
                  <p className="d-inline text-truncate">
                    {customerDetails?.addressCity
                      ? customerDetails.addressCity
                      : "-"}
                  </p>
                </div>
              </div>
              {/* No of Packages  */}
              <div className=" ">
                :&nbsp;&nbsp;&nbsp;
                <p className="d-inline text-truncate">
                  {customerDetails?.addressState
                    ? customerDetails.addressState
                    : "-"}
                </p>
              </div>
              {/* No of Packages  */}
              <div className="">
                :&nbsp;&nbsp;&nbsp;
                <p className="d-inline text-truncate">
                  {customerDetails?.addressZipCode
                    ? customerDetails.addressZipCode
                    : "-"}
                </p>
              </div>
              {/* No of Packages  */}
              <div className="">
                :&nbsp;&nbsp;&nbsp;
                <p className="d-inline text-truncate">
                  {customerDetails?.addressCountry
                    ? customerDetails.addressCountry
                    : "-"}
                </p>
              </div>
            </div>
          </div>

          <hr className="me-2" />
          {/*   Shipping Address
           ********************************************* */}
          <div className="d-flex justify-content-between align-items-center w-100">
            <h4 className="border-bottom border-secondary">SHIPPING ADDRESS</h4>
          </div>
          <div className="w-100 d-flex mb-2">
            <div className="d-flex flex-column" style={{ minWidth: 110 }}>
              <div className="">Customer</div>
              <div className="">Address Line 1</div>
              <div className="">Address Line 2</div>
              <div className="">City</div>
              <div className="">State</div>
              <div className="">Zip Code</div>
              <div className="">Country</div>
            </div>

            <div className="">
              <div className="">
                :&nbsp;&nbsp;&nbsp;
                <p className="d-inline text-truncate">
                  {defaultShippingAddress?.companyName !== ""
                    ? defaultShippingAddress?.companyName
                    : "-"}
                </p>
              </div>
              <div className="">
                :&nbsp;&nbsp;&nbsp;
                <p className="d-inline text-truncate">
                  {defaultShippingAddress?.addressLine1 !== ""
                    ? defaultShippingAddress?.addressLine1
                    : "-"}
                </p>
              </div>
              <div className="">
                :&nbsp;&nbsp;&nbsp;
                <p className="d-inline text-truncate">
                  {defaultShippingAddress?.addressLine2 !== ""
                    ? defaultShippingAddress?.addressLine2
                    : "-"}
                </p>
              </div>
              <div className="">
                :&nbsp;&nbsp;&nbsp;
                <p className="d-inline text-truncate">
                  {defaultShippingAddress?.city !== ""
                    ? defaultShippingAddress?.city
                    : "-"}
                </p>
              </div>
              <div className="">
                :&nbsp;&nbsp;&nbsp;
                <p className="d-inline text-truncate">
                  {defaultShippingAddress?.state !== ""
                    ? defaultShippingAddress?.state
                    : "-"}
                </p>
              </div>
              <div className="">
                :&nbsp;&nbsp;&nbsp;
                <p className="d-inline text-truncate">
                  {defaultShippingAddress?.zip !== ""
                    ? defaultShippingAddress?.zip
                    : "-"}
                </p>
              </div>
              <div className="">
                :&nbsp;&nbsp;&nbsp;
                <p className="d-inline text-truncate">
                  {defaultShippingAddress?.country !== ""
                    ? defaultShippingAddress?.country
                    : "-"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*  Payable Modal
       ********************************************* */}
      <Modal
        // size="lg"
        show={showPayableModal}
        onHide={() => setShowPayableModal(false)}
      >
        <Modal.Body>
          <div className="px-2 pb-2">
            <div
              style={{ width: "fit-content" }}
              className="border-bottom mb-2"
            >
              <h3 className="">Customer Account Details</h3>
            </div>

            <form onSubmit={updateAccountPayable}>
              {isLoading && <Spinner />}
              <div className="row">
                <div className="col-md-12">
                  {/*   Billing Address
                   ********************************************* */}
                  <div className="d-flex align-items-center justify-content-between">
                    <h4 className="mb-0">Billing Address</h4>
                    <div className="d-flex align-items-center gap-2">
                      <button
                        type="button"
                        className="btn btn-link p-0 border-0 lh-1"
                        title="Verify address on Google Maps"
                        disabled={!buildBillingAddressQuery(formData)}
                        onClick={() =>
                          window.open(
                            `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                              buildBillingAddressQuery(formData)
                            )}`,
                            "_blank",
                            "noopener,noreferrer"
                          )
                        }
                      >
                        <i className="mdi mdi-map-marker-check fs-5"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-link p-0 border-0 lh-1"
                        title="Search address on Google"
                        disabled={!buildBillingAddressQuery(formData)}
                        onClick={() =>
                          window.open(
                            `https://www.google.com/search?q=${encodeURIComponent(
                              buildBillingAddressQuery(formData)
                            )}`,
                            "_blank",
                            "noopener,noreferrer"
                          )
                        }
                      >
                        <i className="mdi mdi-magnify fs-5"></i>
                      </button>
                    </div>
                  </div>
                  <hr className="mt-0" />
                  <div className="row mb-1">
                    <label className="col-3 my-auto">Customer</label>
                    <div className="col-9 ">
                      <input
                        type="text"
                        value={formData?.addressCompany}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            addressCompany: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter customer name"
                      />
                    </div>
                  </div>
                  {/* <div className="row mb-1">
                    <label className="col-3 my-auto">Contact</label>
                    <div className="col-9 ">
                      <input
                        type="text"
                        value={formData?.addressContact}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            addressContact: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter contact"
                      />
                    </div>
                  </div> */}
                  <div className="row mb-1">
                    <label className="col-3 my-auto">Address 1</label>
                    <div className="col-9 ">
                      <input
                        type="text"
                        value={formData?.addressLine1}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            addressLine1: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter address 1"
                      />
                    </div>
                  </div>
                  <div className="row mb-1">
                    <label className="col-3 my-auto">Address 2</label>
                    <div className="col-9 ">
                      <input
                        type="text"
                        value={formData?.addressLine2}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            addressLine2: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter address 2"
                      />
                    </div>
                  </div>

                  <div className="row mb-1">
                    <label className="col-3 my-auto">
                      City / State / Zipcode
                    </label>
                    <div className="col-9 ">
                      <div className="d-flex">
                        <input
                          type="text"
                          value={formData?.addressCity}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              addressCity: e.target.value,
                            })
                          }
                          className="form-control w-50"
                          placeholder="City"
                        />
                        <input
                          type="text"
                          value={formData?.addressState}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              addressState: e.target.value,
                            })
                          }
                          style={{ width: "20%" }}
                          className="form-control"
                          placeholder="State"
                        />
                        <input
                          type="number"
                          value={formData?.addressZipCode}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              addressZipCode: e.target.value,
                            })
                          }
                          style={{ width: "30%" }}
                          className="form-control"
                          placeholder="Zipcode"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mb-1">
                    <label className="col-3 my-auto">Country</label>
                    <div className="col-9 ">
                      <input
                        type="text"
                        value={formData?.addressCountry}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            addressCountry: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter country"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/*   Buttons
               ********************************************* */}
              <div className="mt-3 flex-grow-1 d-flex justify-content-end align-items-end">
                <div>
                  <button
                    onClick={() => setShowPayableModal(false)}
                    type="button"
                    className="btn btn-secondary me-1 px-1"
                  >
                    CLOSE
                  </button>
                  <button type="submit" className="btn btn-primary">
                    UPDATE
                  </button>
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AccountPayable;
